import type { TOC } from '@ember/component/template-only'
import { ThStandard } from 'teacher-ui-client/components/th/standard'
import { t } from 'ember-intl'
import { formatValue } from 'teacher-ui-client/utils/format-value'
import type { AwardsOverviewReportData } from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/index/route'

interface Args {
  isLoading?: boolean
  overviewData: AwardsOverviewReportData['overview']
}
interface Signature {
  Args: Args
  Element: HTMLTableElement
}
export const StudentAwardsOverview: TOC<Signature> = <template>
  <table class="border-oceany-blue-150 border-b text-center" ...attributes>
    <thead class="bg-oceany-blue-50">
      <tr class="divide-x divide-white">
        <ThStandard class="w-1/3">
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.gold"}}
        </ThStandard>
        <ThStandard class="w-1/3">
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.silver"}}
        </ThStandard>
        <ThStandard class="w-1/3">
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.bronze"}}
        </ThStandard>
      </tr>
    </thead>
    <tbody class="divide-oceany-blue-150 divide-y {{if @isLoading 'opacity-50'}}">
      <tr>
        <td class="p-3">{{formatValue @overviewData.gold replacement="0"}}</td>
        <td class="p-3">{{formatValue @overviewData.silver replacement="0"}}</td>
        <td class="p-3">{{formatValue @overviewData.bronze replacement="0"}}</td>
      </tr>
    </tbody>
  </table>
</template>

export default StudentAwardsOverview
